// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    function scrollAnimation () {
        $.fn.visible = function(partial) {
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top + 200,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

        let animatedComponent = $('.animate-in'),
            backgroundTextComponent = $('.background-text');

        // Already visible modules
        animatedComponent.each(function(i, el) {
            var $this = $(el);

            if ($this.visible(true)) {
                $this.addClass('already-visible');
            }
        });

        $(window).scroll(function(event) {
            animatedComponent.each(function(i, el) {
                var $this = $(el);

                if ($this.visible(true)) {
                    $this.addClass('is-animated');
                }
            });
        }), {
           capture: true,
           passive: true
        };

        $(window).scroll(function(event) {
            backgroundTextComponent.each(function(i, el){
                var $this = $(el);
                var windowTop = $(window).scrollTop();
                var elementTop = $this.offset().top - 1000;
                var leftPosition = windowTop - elementTop;

                $this.css("transform", 'translateX('+leftPosition+'px)');
            });
        });
    };

    scrollAnimation();
});
